module.exports = __webpack_public_path__ + "static/media/arrow-down-big.ee07d5db.svg";